import React from "react";

import { LazyMotion, m } from "framer-motion";

const loadFeatures = () => {
  return import("../components/parts/FramerFeatures.js").then(
    (res) => res.default
  );
};

const FramerMotionWrapper = ({ children, ...props }) => {
  return (
    <LazyMotion features={loadFeatures}>
      <m.div
        id="player_main_row"
        animate={props.mainPlayerCSS}
        transition={{ duration: 1 }}
      >
        {children}
      </m.div>
    </LazyMotion>
  );
};

export default FramerMotionWrapper;
